import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { StorageService } from "../service/storage.service";
import { UserAttributeService } from "../service/finzy-flex/user/user-attribute.service";

@Injectable()
export class LenderBasicInfoResolver implements Resolve<any> {
    private readonly storageService: StorageService;
    private readonly userAttributeService: UserAttributeService;

    constructor(
        storageService: StorageService,
        userAttributeService: UserAttributeService,
    ) {
        this.storageService = storageService;
        this.userAttributeService = userAttributeService;
    }

    async resolve(): Promise<any> {
        const lenderId = this.storageService.getItem('lender_id');
        const lenderBasicInfo = await this.userAttributeService.getLenderBasicInfo(lenderId);
        if (lenderBasicInfo) {
            return lenderBasicInfo;
        }
        return null;
    }
}